import styled from 'styled-components';

export const ProgressTipWrapper = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: row;
  align-items: flex-start;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.black1};

  span {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  }
`;
